import "./sass/private.scss";
import { eventLoader } from "@otto-ec/global-resources/event-loader";
import { registerFilterSheetHandlers } from "./filtersheet/FilterSheetHandlers";
import { registerFilterSheetTracking } from "./filtersheet/FilterSheetTracking";
import { registerFilterSheetHistory } from "./filtersheet/FilterSheetHistory";
import { registerQuickFilterButtonHandlers } from "./quickfilter/QuickFilterButton";
import registerSearchableFacetHandlers from "./filter/SearchableFacet";
import registerFilterFormActionsHandlers from "./filter/FilterFormActions";
import { SubmitOnChangeListener } from "./filter/SubmitOnChange";
import { initToggles, isAnyActive } from "./toggle/Toggle";
import registerExpanderHandlers from "./expander/Expander";

import "./filter/FilterSection";
import { OverflowBox } from "./overflowBox/OverflowBox";
import { getActiveVariation, initExperiments } from "./experiment/Experiments";
import { registerFilterSheetEventListeners } from "./filtersheet/FilterSheetEventListeners";
import { registerFilterReloading } from "./multifiltering/init";
import { registerSheetOverflowBoxTrackingHandlers } from "./overflowBox/SheetInlineFilterOverflowBoxTracking";
import { registerSheetExpanderTrackingHandlers } from "./expander/SheetInlineFilterExpanderTracking";
import { registerFilterFormSelectAllButtons } from "./filter/form/SelectAllButton";
import { registerPopularFacetValuesListeners } from "./filter/PopularFacetValues";
import { registerSorting } from "./sorting/init";
import { registerRefinementBar } from "./refinementBar/init";
import { registerFilterStuff } from "./filter/init";
import { FilterSorting } from "./filter/FilterSorting";
import { FilterSection } from "./filter/FilterSection";
import NextBestActionBanner from "./nextBestAction/NextBestActionBanner";
import { registerShowMore } from "./showMore/init";
import NextBestActionFacetValueTags from "./nextBestAction/NextBestActionFacetValueTags";
import SizesPersonalization from "./personalization/SizesPersonalization";
import SizesPersonalizationBanner from "./personalization/SizesPersonalizationBanner";
import SizesPersonalizationFilterSheet from "./personalization/SizesPersonalizationFilterSheet";
import { Slider } from "./filter/slider/Slider";
import registerFilterTracking from "./filter/FilterTracking";
import OttoSwitchBanner from "./switchBanner/OttoSwitchBanner";

eventLoader.onReady(1, () => {
  initToggles();
  initExperiments();
});

eventLoader.onReady(2, () => {
  registerExpanderHandlers();
  OverflowBox.register();
});

eventLoader.onReady(3, () => {
  Slider.register();
  registerFilterSheetHandlers();
  FilterSection.register();
  registerFilterSheetEventListeners();
  registerFilterSheetHistory();
  registerFilterSheetTracking();
  registerQuickFilterButtonHandlers();
  registerSheetOverflowBoxTrackingHandlers();
  registerSheetExpanderTrackingHandlers();
  registerSearchableFacetHandlers();
  registerFilterFormSelectAllButtons();
  registerFilterFormActionsHandlers();
  registerFilterStuff();
  registerSorting();
  SubmitOnChangeListener.register();
  registerPopularFacetValuesListeners();
  if (
    isAnyActive("HEUREKA_1363_RETAILER_OTTO_TOGGLE_E3245", "HEUREKA_1363_RETAILER_OTTO_TOGGLE") &&
    getActiveVariation("e3245", "StatusQuo") == "Toggle"
  ) {
    OttoSwitchBanner.register();
  }
  if (isAnyActive("HEUREKA_1032_NEXT_BEST_ACTION", "HEUREKA_1032_NEXT_BEST_ACTION_E3049")) {
    switch (getActiveVariation("e3049", "StatusQuo")) {
      case "BetaBann":
        NextBestActionBanner.register();
        break;
      case "DirectNBA":
        NextBestActionFacetValueTags.register();
        break;
      default:
        /*                                     */
        NextBestActionBanner.registerStatusQuo();
    }
  }
  registerRefinementBar();
  registerFilterTracking();
  registerFilterReloading();
  FilterSorting.register();
  registerShowMore();
  if (
    isAnyActive("HEUREKA_1142_PERSONALIZATION_SAVE_SIZES", "HEUREKA_1142_PERSONALIZATION_SAVE_SIZES_E3095") &&
    getActiveVariation("e3095", "StatusQuo") === "SaveSizes"
  ) {
    SizesPersonalization.register();
    SizesPersonalizationFilterSheet.register();
    SizesPersonalizationBanner.register();
  }
});
